import UserDetailRoute from './UserDetailRoute';

export default UserDetailRoute;
